module.exports = __webpack_public_path__ + "img/logo.d2135c6a.png";